import chroma from 'chroma-js'

// @param color
// @return chroma colour scale
export const ColorScale = color =>
  chroma
    .scale(['white', color, 'black'])
    .domain([0, 100])
    .mode('lch')
